export default __webpack_public_path__ + "static/media/gallery_02.4ad53b59.jpg";